module.exports = __webpack_public_path__ + "static/sec3-27da78788c9a8f4201db2650160dff9e.png";